import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {Subscription} from "rxjs";
import {UserApiService} from "../../../cross/user/api/user-api.service";
import {ProfileDto, UserPhotoDto} from "../../../cross/user/types/user.types";
import {Form, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {DomSanitizer} from "@angular/platform-browser";
import {RegistrationRequestOtpDto} from "../../../rg/types/registration.types";
import {AuthService} from "../../../core/service/auth.service";
import {UserProfileService} from "../../service/user-profile.service";
import {Router} from "@angular/router";
import {AppMessageService} from "../../../core/service/app-message.service";
import {MessageHelper} from "../../../core/helper/message-helper";


@Component({
  selector: 'update-phone',
  templateUrl: './update-phone.component.html',
  styleUrls: ['update-phone.component.scss']
})
export class UpdatePhoneComponent extends CoreComponent implements OnInit {

  formGroup: FormGroup | undefined;

  constructor(protected userProfileService: UserProfileService,
              protected formBuilder: FormBuilder,
              protected router: Router,
              protected messageService: AppMessageService,
              protected authService: AuthService) {
    super();
  }


  override ngOnInit() {
    super.ngOnInit();

    this.refreshComponent();
  }


  refreshComponent() {
    this.buildFormGroup();
    this.initialized = true;
  }

  buildFormGroup() {
    this.formGroup = this.formBuilder.group({
      phone: ['', Validators.required],
      password: [null, Validators.required]
    });

    this.formGroup.patchValue({
      phone: this.userProfileService.phone
    })

  }

  updatePhone() {

    this.busy = true;
    const phone = '+49' + this.formGroup?.get('phone')?.value;
    const password = this.formGroup?.get('password')?.value;

    this.authService.updatePhone(phone, password).subscribe(res => {
        MessageHelper.showSuccessMessage(res.data as string, this.messageService);
        this.router.navigate(['ds/us/profile']);
        this.busy = false;
      },
      error => {
        MessageHelper.showErrorMessage(error.error.data, this.messageService);
        this.busy = false;
      }
    );
  }

}
